<template>
  <div class="staffView common_contentBox">
    <div class="common_search">
      <el-row :gutter="80">
        <el-col :xs="12" :sm="12" :md="10" :lg="10" :xl="10">
          <el-input placeholder="请输入内容" v-model="form.userName" class="input-with-select">
            <el-button slot="append" icon="el-icon-search" @click="searchBtn" />
          </el-input>
        </el-col>
      </el-row>
    </div>
    <commonTable ref="staffViewTable" />
    <editEmployeeDialog
      :edit-employee-show="editEmployeeShow"
      :row-data="rowData"
      @dialogCloseHandle="editEmployeeClose"
      @submitHandle="editEmployeeSubmit"
    />
  </div>
</template>

<script>
import commonTable from '@/components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';
import editEmployeeDialog from './editEmployeeDialog';
import { roleManagementApi } from '../../service';

export default {
  data () {
    return {
      form: {},
      editEmployeeShow: false,
      rowData: {}
    };
  },
  components: {
    commonTable,
    editEmployeeDialog
  },
  methods: {
    editEmployeeSubmit (data) {
      this.$store.commit('setSubPageLoading', true);
      roleManagementApi.editEmployee(data).then(res => {
        if (res.status === '200') {
          this.editEmployeeShow = false;
          this.$message.success('编辑成功');
          this.searchBtn();
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    editHandle (row) {
      this.rowData = JSON.parse(JSON.stringify(row));
      this.editEmployeeShow = true;
    },
    editEmployeeClose () {
      this.editEmployeeShow = false;
    },
    searchBtn () {
      this.$refs.staffViewTable.pageData.pageNum = 1;
      this.$refs.staffViewTable.getTableData({ url: '/lead/role-management/user/list', params: this.form });
    },
    loadTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title('工号')
          ._width('10%')
          ._data('userId')
      );
      tableRow.push(
        new TableColumns()
          ._title('员工姓名')
          ._width('20%')
          ._data('userName')
      );
      tableRow.push(
        new TableColumns()
          ._title('职位')
          ._width('8%')
          ._data('bigArea')
      );
      tableRow.push(
        new TableColumns()
          ._title('主属部门')
          ._width('8%')
          ._data('deptName')
      );
      tableRow.push(
        new TableColumns()
          ._title('角色')
          ._width('8%')
          ._data('roles')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let roleList = row.roles.map(item => {
                return item.roleName;
              });
              return (
                <div>
                  {
                    roleList.join(',')
                  }
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('操作')
          ._width('12%')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button type="text" onClick={() => { this.editHandle(row); }}>
                    编辑
                  </el-button>
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$refs.staffViewTable.setColumn(column);
      this.$refs.staffViewTable.loadTable({ url: '/lead/role-management/user/list', listKey: 'userVOList' });
    }
  },
  mounted () {
    this.loadTable();
  }
};
</script>

<style scoped>
</style>
